import { DateTime } from "luxon";
import { useContext } from "react"
import { FeatureContext } from "../../../Context"
import { formatDate } from "../../../Utils";
import CreateComment from "./CreateComment";

const Comments = () => {
  const context = useContext(FeatureContext);

  const sortComments = context?.comments
    .sort((a, b) =>
      new Date(a.lastModifiedDate) - new Date(b.lastModifiedDate));

  return <div className="bf-enquiry-comments">
    <div className="bf-enquiry-comments-inner">
      {sortComments.map((comment, index) =>
        <div key={'comment-' + index}
          className={`bf-enquiry-comment ${(comment.sender === 'bonfiglioli') ? 'sender' : 'receiver'}`}>
          <div className="bf-enquiry-comment-date">{formatDate(comment.lastModifiedDate)}</div>
          <div className="bf-enquiry-comment-message">{comment.commentBody}</div>
        </div>
      )}
    </div>
    <CreateComment />
  </div>

}

export default Comments